import { Component } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import addComponentAnimation from '@swisslife/shared-ui/src/utils/animations/js/animations';

import '../../../molecules/teaser/js/teaser';
import '../../../molecules/marketing-teaser/js/marketing-teaser';

// add your selector here, e.g. Element = '.js-m-teaser-row',
enum Selectors {
	Item = '.js-m-teaser-row__col',
}

// The @Component decorator will connect the class with `data-g-name="TeaserRow"` elements.
@Component('TeaserRow')
export class TeaserRow extends GondelJqueryComponent {
	private controllers: any[] = Array();

	public async sync() {
		this.controllers = await addComponentAnimation(this.$ctx, Selectors.Item);
	}

	public stop() {
		for (const controller of this.controllers) {
			controller.destroy(true);
		}
	}
}
